import { parseEntities } from "parse-entities";
import { graphql } from "gatsby";

export const headingToAnchor = (block) => {
  return (
    block.attributes.anchor || slugify(stripHtml(block.attributes.content))
  );
};

export const stripHtml = (htmlText) =>
  parseEntities(htmlText.replace(/(<([^>]+)>)/gi, ""));

export const slugify = (text) =>
  text
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");

export const blogImageQuery = graphql`
  fragment BlogImage on WpMediaItem {
    altText
    localFile {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 700, placeholder: DOMINANT_COLOR)
      }
    }
  }
`;
